export default "__VITE_ASSET__1172d722__"